import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Approach } from './pages/Approach';
import { Locations } from './pages/Locations';
import { Insights } from './pages/Insights';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mjpwvhnj9igv">
      <ScrollToTop data-id="element-1" data-mp="31aqeoda66opo" />
      <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-2" data-mp="31b8fzobovt4g">
        <SiteHeader data-id="element-3" data-mp="31cjjro54x0vk" />
        <div className="flex-1" data-id="element-4" data-mp="2wjgqzi86lvgf">
          <Routes data-id="element-5" data-mp="2wj8f9tnsow6t">
            <Route path="/" element={<Home data-id="element-7" data-mp="28ufqch5lbolp" />} data-id="element-6" data-mp="2wip6p3k1bk5g" />
            <Route path="/services" element={<Services data-id="element-9" data-mp="28suumo7jhzm9" />} data-id="element-8" data-mp="28tw3qn4zwc1c" />
            <Route path="/approach" element={<Approach data-id="element-11" data-mp="23vune9yyeqtk" />} data-id="element-10" data-mp="28sbe9bxjfjac" />
            <Route path="/locations" element={<Locations data-id="element-13" data-mp="23t8g8bfz6dbv" />} data-id="element-12" data-mp="23ujkecdc1n3i" />
            <Route path="/insights" element={<Insights data-id="element-15" data-mp="3iiwaeb4natww" />} data-id="element-14" data-mp="3ik7eyd5x05p2" />
            <Route path="/about" element={<About data-id="element-17" data-mp="3mlj8uuvtnd32" />} data-id="element-16" data-mp="3ijpdn24eb1aa" />
            <Route path="/contact" element={<Contact data-id="element-19" data-mp="3mjzu58ptda3e" />} data-id="element-18" data-mp="3mkrefndynled" />
            <Route path="*" element={<Home data-id="element-21" data-mp="3rcj31sdk3h1v" />} data-id="element-20" data-mp="3mj6hxs835sdv" />
          </Routes>
        </div>
        <SiteFooter data-id="element-22" data-mp="3rd19tixuhdo1" />
      </div>
    </BrowserRouter>;
}